<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div style="background: rgba(0, 0, 0, 0.12); padding: 10px; height: 90px; width: 130px">
  <img [httpSrc]="imageUrl" style="width: 100%; height: 100%; object-fit: contain" />
</div>
